














































import Vue from "vue";
import { ApiResponseStatusEnum } from "../../../model/communication/ApiResponseStatusEnum";
import { ChangePasswordCommand } from "@/model/communication/auth/ChangePasswordCommand";
import Password from "vue-password-strength-meter";
import { mapState } from "vuex";
import { RootState } from "@/store";
import { ApplicationState } from "@/store/modules/ApplicationModule";
import { ConfigurationEntry } from "@/model/communication/application/GetServerConfigurationResponse";
import { CReqExecutionResultEnum } from "@/model/communication/CReqExecutionResultEnum";

const minScoreKey: string = "minScore";
const minCharactersKey: string = "minCharacters";
const differentPwKey: string = "differentPw";

const defaultMinScore: number = 3;
const defaultMinCharacters: number = 8;
const defaultDifferentPw: number = -1;

export default Vue.extend({
    components: { Password },
    data() {
        return {
            passwordTyped1: null,
            passwordTyped2: null,
            currentScore: 0,
            suggestions: null,
            warning: null,
            loading: false,
            showPassword: false,
            showErrorAlert: false,
            errorAlertMessage: null,
        };
    },
    props: ["pwExpired"],
    computed: {
        ...mapState({
            passwordPolicy: function (state: RootState): ConfigurationEntry[] {
                return (state.application as ApplicationState).configurationEntries.filter((c) => c.section == "PASSWORD_POLICY");
            },
        }),

        minScoreRequired() {
            try {
                var value = Number((this.passwordPolicy.find((c: ConfigurationEntry) => c.key == minScoreKey) as ConfigurationEntry).value);
                return value >= 0 ? value : defaultMinScore;
            } catch (error) {
                console.error("Cannot read ", minScoreKey, " value from server pw policy configuration. Set it to ", defaultMinScore, " as default.");
                return defaultMinScore;
            }
        },

        secureLength() {
            try {
                var value = Number((this.passwordPolicy.find((c: ConfigurationEntry) => c.key == minCharactersKey) as ConfigurationEntry).value);
                return value >= 0 ? value : defaultMinCharacters;
            } catch (error) {
                console.error("Cannot read ", minCharactersKey, " value from server pw policy configuration. Set it to ", defaultMinCharacters, " as default.");
                return defaultMinCharacters;
            }
        },

        differentPw() {
            try {
                var value = Number((this.passwordPolicy.find((c: ConfigurationEntry) => c.key == differentPwKey) as ConfigurationEntry).value);
                return value >= 0 ? value : defaultDifferentPw;
            } catch (error) {
                console.error("Cannot read ", differentPwKey, " value from server pw policy configuration.");
                return defaultDifferentPw;
            }
        },

        samePassword() {
            return this.passwordTyped1 != null && this.passwordTyped2 != null && this.passwordTyped1.length > 0 && this.passwordTyped2 == this.passwordTyped1;
        },

        submitAvailable() {
            // return true;
            if (this.minScoreRequired == undefined) return false;
            return this.samePassword && this.currentScore >= this.minScoreRequired && this.passwordTyped1.length >= this.secureLength;
        },
    },
    methods: {
        async onSubmitClick() {
            if (!this.loading && this.submitAvailable) {
                try {
                    this.loading = true;
                    var res = await new ChangePasswordCommand(this.passwordTyped1).execute();
                    if (res.responseStatus == ApiResponseStatusEnum.Success) {
                        this.reset();
                        this.$emit("close");
                    } else {
                        if (res.errorMessage == CReqExecutionResultEnum.InvalidRequest) {
                            this.showErrorAlert = true;
                            this.errorAlertMessage = this.$t("login.same_pw") + " " + (this.differentPw >= 0 ? this.differentPw : "");
                        }
                    }
                    this.loading = false;
                } catch (error) {
                    this.showErrorAlert = true;
                    this.errorAlertMessage = this.$t("login.same_pw") + " " + (this.differentPw >= 0 ? this.differentPw : "");
                    this.loading = false;
                }
            }
        },

        onFeedbackChange({ suggestions, warning }) {
            this.suggestions = suggestions;
            this.warning = warning;
        },

        onScoreChange(score) {
            this.currentScore = score;
        },

        reset() {
            this.passwordTyped1 = null;
            this.passwordTyped2 = null;
            this.currentScore = 0;
            this.suggestions = null;
            this.warning = null;
            this.loading = false;
            this.showPassword = false;
            this.showErrorAlert = false;
        },
    },
});
